import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";
import { relatedLegalLinks, LEGAL_SHARED } from "../config/legal";
import { SITE } from "../config/site";

const bullets = (items) => ({ type: "bullets", items });

export default function SubscriptionTermsPage() {
  const sections = [
    {
      id: "plans",
      title: "1. Plans and prices",
      blocks: [
        "Paid website plans are Stratify Pro and Stratify Elite. Displayed prices on the pricing page come from Stratify’s approved catalog.",
        bullets([
          "New Pro subscriptions: $19.99 USD per month.",
          "New Elite subscriptions: $39.99 USD per month.",
        ]),
        "Existing valid annual or CAD subscriptions continue under their original terms until they end or are changed. Checkout or the App Store shows the amount you will be charged before you pay.",
        LEGAL_SHARED.simulation,
        LEGAL_SHARED.noLiveTrading,
      ],
    },
    {
      id: "renewal",
      title: "2. Renewal and currency",
      blocks: [
        "New website subscriptions renew monthly until cancelled. Existing annual subscriptions follow their existing billing period.",
        "New website prices are offered in USD. Apple prices follow the App Store storefront.",
        "Website subscriptions are initially offered in the United States and Canada. Other countries are not offered yet.",
      ],
    },
    {
      id: "tax",
      title: "3. Tax",
      blocks: [
        "Catalog prices exclude tax unless Checkout itemizes tax. Applicable tax may be added at Checkout based on your location. The charge screen shows any tax that is actually collected before you pay.",
      ],
    },
    {
      id: "cancel",
      title: "4. Cancellation",
      blocks: [
        "Cancellation stops renewal. Access continues through the end of the paid period.",
        "Stripe / website: after website billing is available, cancel in the Stripe Customer Portal from the pricing page while signed in with the same account.",
        "Apple: cancel in iOS Settings → Apple ID → Subscriptions, or on the Apple subscriptions page.",
        { type: "link", href: SITE.appleSubscriptionsUrl, label: "Apple subscriptions" },
        "Deleting the app does not by itself cancel billing. Ask support if you also want the account removed.",
      ],
    },
    {
      id: "failed-payment",
      title: "5. Failed payments",
      blocks: [
        "If a renewal payment fails, email support with your account email. We do not publish a fixed grace period or a guaranteed access window after a failed charge.",
      ],
    },
    {
      id: "plan-changes",
      title: "6. Plan changes",
      blocks: [
        "Stripe website subscribers can use the Customer Portal to change between Pro and Elite. The portal previews any amount due or credit before confirmation.",
        `For help with a plan change, email ${SITE.supportEmail}. Apple subscribers manage their plans through Apple Subscriptions.`,
      ],
    },
    {
      id: "after-cancel",
      title: "7. After cancellation",
      blocks: [
        "Cancellation normally stops renewal at the end of the paid period. Access continues through that paid term.",
        "After the paid term ends, the account uses the Free plan. Ask support if you need help with data or limits.",
      ],
    },
    {
      id: "sellers",
      title: "8. Stripe and Apple",
      blocks: [
        LEGAL_SHARED.sellers,
        "Do not start a second paid subscription on the other store if you already have an active subscription. Manage the subscription where you bought it.",
        LEGAL_SHARED.marketing,
      ],
    },
    {
      id: "website-status",
      title: "9. Website Checkout status",
      blocks: [
        "Public website Checkout remains disabled until Stratify verifies the production billing service. The App Store is the current purchase path when Apple in-app purchases are available.",
        { type: "internalLink", to: "/pricing", label: "View pricing" },
        { type: "internalLink", to: "/refund-policy", label: "Refund Policy" },
      ],
    },
  ];

  return (
    <LegalDocumentPage
      badge="Subscription Terms"
      title="Subscription Terms"
      description="Recurring billing, renewal, cancellation, tax, and what happens to premium access after you cancel."
      sections={sections}
      relatedLinks={relatedLegalLinks("/subscription-terms")}
      path="/subscription-terms"
    />
  );
}
